import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
import { useOutlet } from 'react-router-dom';
import Media from 'src/utils/media';

const { Content } = Layout;

const PublicLayout: React.FC = () => {
  const outlet = useOutlet();
  return (
    <PublicLayoutStyle>
      <Layout className="layout-body">
        <Content className="body-content">{outlet}</Content>
      </Layout>
    </PublicLayoutStyle>
  );
};

export default PublicLayout;

const PublicLayoutStyle = styled(Layout)`
  height: 100%;
  width: 100%;
  min-height: 100vh;
  position: relative;
  .layout-body {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .body-content {
      width: 100%;
      margin: 0 auto;
      ${Media.lessThan(Media.SIZE.XL)} {
        max-height: 100%;
      }
    }
    ${Media.lessThan(Media.SIZE.MD)} {
      .body-content {
        padding: 20px 0px;
      }
    }
    .body-footer {
      text-align: center;
    }
  }
`;
